import { PromptData } from '../types';

export function generatePrompt(data: PromptData): string {
  return `You are an expert AI assistant specializing in ${data.industry}. I need your help to ${data.goal} about ${data.topic}.

Target Audience: ${data.audience}
Tone of Voice: ${data.tone}
Complexity Level: ${data.complexity}
Output Format: ${data.format}

Please provide a comprehensive response that:
1. Is specifically tailored for ${data.audience}
2. Maintains a ${data.tone.toLowerCase()} tone throughout
3. Matches a ${data.complexity.toLowerCase()} level of understanding
4. Follows a ${data.format.toLowerCase()} structure
5. Incorporates industry-specific best practices for ${data.industry}
6. Includes practical examples and actionable steps
7. Considers current trends and standards
8. Focuses on measurable outcomes

Format your response in a clear, structured manner that optimizes readability and implementation.`;
}